<template>
  <div class=" is-fullwidth">
    <div class="level">
        <div class="level-left">
          <div class="columns" >
              

             <div class=" col">
                &nbsp;<input type="date" class="input" v-model="start_date" />
                
              </div>
              <div class=" col" >
                &nbsp;<input type="date" class="input" v-model="end_date" />
                
              </div>

              <div class="col">
                  <table class="table is-hoverable is-bordered " id="overviewtable" >
                    <tbody>
                      <tr>
                        <td class="">Total  Orders</td>
                        <td>{{ orders.length }}</td>
                      
                        </tr>
                    </tbody>
                  </table>
                </div>
            </div>
      </div>
        
      </div>
    
   

    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" >
    	<thead>
    		<tr>
        <th>PO Number</th>
        <th>Customer</th>
        <th>Garment</th>
        <th>Design</th>
          <th>Order Date</th>
          <th>Total</th>
         <th>0_6</th>
         <th>6_12</th>
         <th>1_2</th>
          <th>&nbsp;</th>
   	 	    </tr>
    	</thead>
    	<tbody>
		    <tr v-if="orders_loading===true">
          <td colspan="10"><strong>Loading orders ...</strong></td>
          </tr>
        <tr v-for="order in orders" v-bind:key="order.orderID" v-show="orders_loading===false">
          <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
           <td>{{order.designname}}</td>
          <td>{{order.orderdate}}</td>
           <td>{{ order.total_qty }}</td>
         <td>{{ order['0_6_childrens'] + order['0_6_childrens_GK'] }}</td>
         <td>{{ order['6_12_childrens'] + order['6_12_childrens_GK'] }}</td>
         <td>{{ order['1_2_childrens'] + order['1_2_childrens_GK'] }}</td>
           
          <td>
            <a :href="VUE_APP_ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-info is-small">View</button></a>
          </td>
          
             
              
			</tr>
      </tbody>
      
    </table>

    <button @click="exportXLS()" class="button is-info" >Export to Excel</button>

     
    
  </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
//import SalesService from '@/services/SalesService.js';
import XLSX from 'xlsx';

export default {
  name:'EarlyOrders',
  components: {
   	
  },
  data() {
    return {
      client_id: '',
       clients: [],
      orders: [],
      users: [],
      username: '',
      start_date: this.getStartDate(),
        end_date: new Date().toISOString().slice(0,10),
      currentSort: 'count',
      currentSortDir: 'desc',
      
     accessToken: '',
     clients_loading:true,
     orders_loading:true,
     VUE_APP_ASP_URL:process.env.VUE_APP_ASP_URL,

     range: '',
     
    }
  },
  created() {
      this.getAccessToken()
        .then(() => { 
            this.getOrdersWithKidsQuantities()
        });
      
    },
  methods: {
    async getAccessToken() {
        this.accessToken = await this.$auth.getTokenSilently()
    },
    exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('orderstable'), {sheet:"Sheet 1"});
		 XLSX.writeFile(wb, 'Orders With Kids Report.xlsx')

	 },
   
    async getOrdersWithKidsQuantities() {
      this.orders_loading=true;
      OrderService.getOrdersWithKidsQuantities(this.accessToken, this.client_id, this.range, this.start_date, this.end_date, "", 1)
          .then(
            (orders => {
              
              this.$set(this, "orders", orders);
              this.orders_loading=false;
            }).bind(this)
          );
    },
    
    getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() - 365);
            return d.toISOString().slice(0,10);
             
        },
   
  },
  computed : {
     
     
  },

 
  mounted() {
    
  },
  watch: {
   
    start_date: function () {
     
      this.getOrdersWithKidsQuantities()
    },
    end_date: function () {
     
      this.getOrdersWithKidsQuantities()
    },
  }
}



</script>


